var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningPink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.928,
    height: 30.929,
    viewBox: "0 0 30.928 30.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "warning_pink_svg__Icon_metro-warning",
    "data-name": "Icon metro-warning",
    d: "M18.035,4.73l12.96,25.831H5.074L18.035,4.73Zm0-2.8A2.235,2.235,0,0,0,16.2,3.277L2.995,29.587c-1.011,1.8-.151,3.269,1.912,3.269H31.163c2.063,0,2.923-1.471,1.912-3.269h0L19.874,3.277A2.235,2.235,0,0,0,18.035,1.928Zm1.933,25.129a1.933,1.933,0,1,1-1.933-1.933A1.933,1.933,0,0,1,19.968,27.058Zm-1.933-3.866A1.933,1.933,0,0,1,16.1,21.258v-5.8a1.933,1.933,0,1,1,3.866,0v5.8A1.933,1.933,0,0,1,18.035,23.191Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#f03737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningPink);
export default __webpack_public_path__ + "static/media/warning_pink.51d23a2895a81b6d92582de4fbe87aaf.svg";
export { ForwardRef as ReactComponent };